import { __assign } from "tslib";
import * as React from 'react';
import { sanitizeHtml } from './sanitizer';
export var RenderHtml = function (props) {
    var skipSanitation = props.dangerouslyDisableSanitation === 'i-know-what-i-am-doing';
    var html = skipSanitation ? props.html : sanitizeHtml(props.html, props.allowedCustomTags, props.allowedCustomAttributes);
    var compProps = { dangerouslySetInnerHTML: { __html: html }, className: props.className };
    return props.useDiv ? React.createElement("div", __assign({}, compProps)) : React.createElement("span", __assign({}, compProps));
};
//# sourceMappingURL=index.js.map